import { contactContent } from '@/mocks/homepage';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
          {contactContent.title}
        </h2>
        <p className="text-primary-500 font-medium mb-3">{contactContent.subtitle}</p>
        <p className="text-sm text-foreground-500 leading-relaxed mb-10 max-w-lg mx-auto">
          {contactContent.desc}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {/* Email */}
          <div className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <span className="text-xs text-foreground-500">电子邮箱</span>
            <span className="text-sm font-medium text-foreground-900">{contactContent.email}</span>
          </div>

          {/* Weibo */}
          <div className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-weibo-line text-xl"></i>
            </div>
            <span className="text-xs text-foreground-500">微博</span>
            <span className="text-sm font-medium text-foreground-900">{contactContent.weibo}</span>
          </div>

          {/* WeChat */}
          <div className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-wechat-line text-xl"></i>
            </div>
            <span className="text-xs text-foreground-500">微信公众号</span>
            <span className="text-sm font-medium text-foreground-900">{contactContent.wechat}</span>
          </div>
        </div>
      </div>
    </section>
  );
}